import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import styled, { css, RuleSet } from 'styled-components'
import { PriceElementBaseProps } from '../../price-element-interface'

interface PriceElementPlansUiStylesInterface extends PriceElementBaseProps {
  isDisabled: boolean
  planCount: number
}

export const PriceElementPlansUi = styled.div<PriceElementPlansUiStylesInterface>`
  display: grid;
  grid-template-columns: repeat(${p => Math.min(p.planCount, 4)}, 1fr);
  gap: 30px;
  margin-top: 50px;

  @media only screen and (min-width: 801px) and (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }


  ${p => p.theme.phone} {
    ${p =>
      !p.isDisabled &&
      css`
        gap: 10px;
        grid-template-columns: auto;
        will-change: transform;
      `}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    (
      !p.isDisabled &&
        css`
          gap: 10px;
          grid-template-columns: auto;
          will-change: transform;
      `
    )}
`

export const PriceElementBottomSectionUi = styled.div`
  display: flex;
  flex-direction: column;
`

export const PriceElementPlanUi = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(24, 28, 57, 0.1);
  box-sizing: border-box;
  min-height: 500px;

  ${p => p.theme.phone} {
    flex: 0 0 100%;
    padding: 25px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      flex: 0 0 100%;
      padding: 25px;
    `}
`

export const PriceElementPlanTitleUi = styled.div<PriceElementBaseProps>`
  color: #181c39;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;

  ${p => p.theme.phone} {
    margin-bottom: 8px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    margin-bottom: 8px;
  `}
`

export const PriceElementPlanDescriptionUi = styled.span`
  color: #5e6075;
  font-size: 20px;

  ${p => p.theme.phone} {
    margin-bottom: 30px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    margin-bottom: 30px;
  `}
`

export interface PriceElementPlanPriceUiProps extends PriceElementBaseProps {
  isSmall?: boolean
}

export const PriceElementPlanPriceUi = styled.span<PriceElementPlanPriceUiProps>`
  color: rgb(24, 28, 57);
  font-size: 60px;
  font-weight: 700;

  ${p =>
    p.isSmall &&
    `
      font-size: 42px;
  `}
`

interface PriceElementPlanSubtitleProps {
  isVisible: boolean
}

export const PriceElementPlanSubtitleUi = styled.span<PriceElementPlanSubtitleProps>`
  color: #5e6075;
  font-size: 18px;
  ${p => !p.isVisible && 'visibility: hidden'}
`

interface PriceElementPlanButtonUiStylesInterface
  extends PriceElementBaseProps {
  isDisabled: boolean
}

const getPriceElementPlanButtonStylesForLocale = (
  locale: PageLocaleEnum,
): RuleSet => {
  switch (locale) {
    case PageLocaleEnum.RUSSIAN:
      return css`
        font-size: 16px;
      `
    case PageLocaleEnum.SPANISH:
      return css`
        font-size: 16px;
      `
    case PageLocaleEnum.CZECH:
      return css`
        font-size: 16px;
      `
    case PageLocaleEnum.POLISH:
      return css`
        @media only screen and (max-width: 1200px) {
          font-size: 13px;
        }
      `

    default:
      return css`
        font-size: 18px;
        line-height: 32px;
      `
  }
}

export const PriceElementPlanButtonUi = styled.button<PriceElementPlanButtonUiStylesInterface>`
  background-color: #00a0ff;
  background-color: ${p => (p.isDisabled ? '#e4e8f0' : '#00a0ff')};
  border-radius: 6px;
  color: white;
  text-align: center;
  font-weight: 600;
  line-height: 32px;
  padding: 12px;
  cursor: ${p => (p.isDisabled ? 'default' : 'pointer')};
  border: none;
  transition: 0.3s;
  margin-top: 24px;

  &:hover:not(:disabled) {
    background-color: #00b4ff
  }

  @media only screen and (max-width: 1200px) {
    font-size: 16px;
    line-height: 30px;
  }

  ${p => p.locale && getPriceElementPlanButtonStylesForLocale(p.locale)}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      font-size: 16px;
      line-height: 30px;
    `}
`
